import { Spinner } from "react-bootstrap";
import styled from "styled-components";

export function LoadingSpinner() {
    return (
        <SpinnerWrapper>
            <Spinner animation="border" role="status" variant="secondary">
                <span className="sr-only">Carregando...</span>
            </Spinner>
        </SpinnerWrapper>
    );
}

const SpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3rem 0;
`;
